import locales from 'apexcharts/src/locales/pt-br.json';

const localization = Object.freeze({
  locales: [locales],
  default: 'pt-br',
});

const colors = Object.freeze({
  FLUSH_ORANGE: '#FF8400',
  RAJAH: '#F2B370',
  COPPER: '#C17E35',
  RED: '#F61010',
  SILVER: '#C7C7C7',
  DOVE_GRAY: '#707070',
  BLACK: '#000000',
});

const font = Object.freeze({
  FAMILY: 'UOLText, Helvetica, Arial, sans-serif',
});

const mobileBreakPoint = 992;

export {
  localization,
  colors,
  font,
  mobileBreakPoint,
};
